import { type PortalProps, Portal as ChakraPortal } from '@chakra-ui/react/portal';
import { type PropsWithChildren } from 'react';
import { useThemeContext } from '../../theme';

export function Portal(props: PropsWithChildren<PortalProps>) {
  const { themeRootRef } = useThemeContext();
  return <ChakraPortal container={themeRootRef} {...props} />;
}
